import React from "react";
import { Link } from "react-router-dom";
import logo from "./Final.png";

export const Navigation = (props) => {
  const apikey = process.env.REACT_APP_API;

  // Function to close navbar on link click
  const handleNavClick = () => {
    window.scrollTo(0, 0);
    const nav = document.getElementById("bs-example-navbar-collapse-1");
    if (nav && nav.classList.contains("in")) {
      // Bootstrap v3 uses 'in' class for open collapse
      window.$("#bs-example-navbar-collapse-1").collapse("hide");
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container-fluid">
        <div className="navbar-header">
          {/* Toggle Button (Mobile) */}
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          {/* Logo */}
          <Link
            to="/"
            className="navbar-brand page-scroll"
            onClick={handleNavClick}
          >
            <img src={logo} alt="logo" className="navbar-logo" />
          </Link>
        </div>

        {/* Navbar Links */}
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">

            <li>
              <Link to="/" className="page-scroll" onClick={handleNavClick}>
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="page-scroll"
                onClick={handleNavClick}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/features"
                className="page-scroll"
                onClick={handleNavClick}
              >
                Features
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="page-scroll"
                onClick={handleNavClick}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/gallery"
                className="page-scroll"
                onClick={handleNavClick}
              >
                Gallery
              </Link>
            </li>
            {/* <li>
              <Link
                to="/testimonials"
                className="page-scroll"
                onClick={handleNavClick}
              >
                Testimonials
              </Link>
            </li> */}
            {/* <li>
              <Link to="/team" className="page-scroll" onClick={handleNavClick}>
                Team
              </Link>
            </li> */}
            <li>
              <Link
                to="/careers"
                className="page-scroll"
                onClick={handleNavClick}
              >
                Careers
              </Link>
            </li>

            <li>
              <Link
                to="/contact"
                className="page-scroll"
                onClick={handleNavClick}
              >
                Contact
              </Link>
            </li>
            {/* <li>
              <a
                href="/admin/auth/signin"
                target="_blank"
                rel="noopener noreferrer"
                className="page-scroll"
                onClick={handleNavClick}
              >
                Sign In
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};
